module.exports = __webpack_public_path__ + "img/電気回路_1_10.7a3a9d85.png";